import {AdmsRepository, AdmsAsset} from './AdmsActions'

/** Описание списка активов */
const initialAssets = {
    state: "empty",         //Состояние загрузки списка активов
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 10,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["IRI", "dsn", "dsv"]},
    distinct: false,
    ordered: true,
    catalog: {},            //Информация о каталоге (dcat:Catalog)
    assets: [],             //Список полученных в результате отбора
};
//Описание ADMS каталога
const initialVAdmsState = {
    ...initialAssets,
    links: {...initialAssets},  //Список активов для связывания (с другими активами, с каталогом и т.п.)
    taxonomy: null,         //Массив элементов вида {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}}
                            //После загруженного содержимого появится элемент concepts c концептами, schema данными схемы и state - состояние
    stack: null,            //Стек значений vadms
    //Список URI графов, в которых хранятся данные. Массив значений {iri: '', state: ''}. 
    //Возможные состояния state: recommended, present, none, error    
    graphs: [],             
};

export const vadms = (state = { ...initialVAdmsState} , action) => {
    switch (action.type) {
        case "AdmsRepository.EMPTY": 
            return{
                ...initialVAdmsState,
                state: "empty"
            }
        case "AdmsRepository.SET_RFILTER": 
            return{
                ...state,
                rfilter: action.rfiter,
                state: "empty",
                assets: [],
            }            
        case "AdmsRepository.LOAD_STARTED": 
            return{
                ...state,
                state: "load"
            }
        case "AdmsRepository.LOAD_ERROR": 
            return {
                ...state,
                state: "error",
                error: action.error
            };            
        case "AdmsRepository.LOAD_CATALOG_DETAILS":
            return {
                ...state,
                catalog: {
                    iri: action.iri,
                    values: action.values,
                    head: action.head, 
                    predicates: action.predicates, 
                    languages: action.languages,
                },
                state: "loaded"
            };
        case "AdmsRepository.LOAD_ASSETS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                assets: action.assets,
                state: "loaded",
            };
        case "AdmsRepository.LOAD_NEXTASSETS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                assets: [...state.assets, ...action.assets],
                state: "loaded",
            };
        case "AdmsRepository.LOAD_LINKASSETS": 
            return {
                ...state,
                links:{
                    offset: action.offset, 
                    limit: action.limit, 
                    count: action.count, 
                    head: action.head, 
                    distinct: action.distinct, 
                    ordered: action.ordered, 
                    assets: action.assets,
                    state: "loaded"
                }
            };
        case "AdmsRepository.LOAD_NEXTLINKASSETS": 
            return {
                ...state,
                links: {
                    offset: action.offset, 
                    limit: action.limit, 
                    head: action.head, 
                    distinct: action.distinct, 
                    ordered: action.ordered, 
                    assets: [...state.links.assets, ...action.assets],
                    state: "loaded",
                },
            };
        case "AdmsRepository.LOAD_THEMETAXONOMY":
            return {
                ...state,
                state: "loaded",
                taxonomy: action.taxonomy.map( 
                    item => Object.assign(item, {context: "THEME"})
                ),
            };
        case "AdmsRepository.LOAD_TAXONOMY":
            const n = (state.taxonomy)?[...state.taxonomy]: [];
            let isExist = false; //Нужно, если элемент отсутствовал
            for (let i=0; i<n.length; i++) {
                if (isExist) break;
                const schema = n[i];
                //Каждый элемент {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}
                //Label: {type: "literal", xml:lang: "ru", value: "Категория семантического актива"}}
                if ((schema.IRI) && (schema.IRI.value==action.taxonomy)){
                    schema.concepts = action.concepts,
                    schema.schema = action.schema;
                    schema.broader = action.broader;
                    schema.identifier = action.identifier;
                    schema.state="loaded";
                    isExist = true;
                }
            }
            if (!isExist){
                const t = {
                    IRI: {type: "uri", value: action.taxonomy}, 
                    concepts: action.concepts, 
                    schema: action.schema, 
                    broader: action.broader,
                    identifier: action.identifier,
                    state: "loaded",
                    context: "TAXONOMY"
                };
                n.push(t);
            }
            return {
                ...state,
                state: "loaded",
                taxonomy: n
            };

        case "AdmsRepository.STATISTICS":
            const {statistics} = state;
            const s = (statistics)?statistics:{};
            s[action.IRI] = (typeof s[action.IRI] ==='undefined')? action.statistic: Object.assign({}, s[action.IRI], action.statistic);
            return {
                ...state,
                statistics: s,
            };
        case "AdmsRepository.STATISTICS_BY_THEME":
            return {
                ...state,
                statistics: action.statistic,
            };            
        case "AdmsRepository.STATISTICS_BY_SCHEME":
            const sbs = (state.statistics)?state.statistics: {};
            Object.keys(action.statistics).forEach(key => {
                if (typeof sbs[key] === 'undefined')
                    sbs[key] = action.statistics[key];
            });
            return {
                ...state,
                statistics: sbs,
            };            
        case "AdmsRepository.ADD_ASSET":
            const added = (state.assets && Array.isArray(state.assets))?[...state.assets]: [];
            added.push({IRI: {type: "uri", value: action.iri},
                    dsn: {type: "literal", value: action.label},
                    dsv: {type: "typed-literal", datatype: "http://www.w3.org/2001/XMLSchema#decimal", value: ""}
            })
            return {
                ...state,
                assets: added,
                state: "added"
            };
        case "AdmsRepository.LINK_ASSET":
            return {
                ...state,
                assets: [...action.assets, ...state.assets],
                state: "linked"
            };
        case "AdmsRepository.REMOVE_ASSET":
            const r = (state.assets && Array.isArray(state.assets))?[...state.assets]: [];
            return {
                ...state,
                assets: r.filter(asset => asset.IRI.value!=action.iri),
                state: "remove"
            };            
        case "AdmsRepository.CONDITIONS":
            return{
                ...state,
                assets: [],
                offset: 0,
                //Изменение статистики при изменении условий отбора требует очистку statistics. 
                //2024-1210 Команда не пересчитывать статистику элементов. Начальная статистика загружается в 
                // ConceptScheme.js loadTaxonomyStatistics() для каждой схемы
                //statistics: {},
                conditions: action.conditions,
                state: "empty"
            }
        case "AdmsRepository.LOAD_DESCRIPTION":
            const nadesc = (state.assets)?[...state.assets]: [];
            for (let i=0; i<nadesc.length; i++) {
                const nadesc_a = nadesc[i];
                if ((nadesc_a.IRI) && (nadesc_a.IRI.value==action.IRI)){
                    nadesc_a.description = action.description;
                    //Если в отбор попадают с IRI дубликатами, то повторно вызывается загрузка описания
                    //break;
                }
            }
            return{
                ...state,
                assets: nadesc,
            }
        case "AdmsRepository.PUSH":
            return {
                ...state,
                stack : {...state}
            }            
        case "AdmsRepository.POP":
            const pop = (state.stack)? state.stack: state;
            return {
                ...pop,
            }            
        default:
            return state;
    }
};

//Дефаултные значения для ассета
const initialVAssetState = {
    state: "empty",     //Состояние ассета
    iri: null,
    head: {             //Заголовок полученных данных. См. результаты запроса в request.js для values_sparql
        link:[],        //Неполнятно зачем возвращается TODO выяснить в документации.
        vars:[]         //Переменные, которые определены в данных (по их названию пожно получить занчение)
    },
    predicates: [],     //Список загруженных предикатов
    languages:  [],     //Список доступных языков (языки для которых есть данные)
    values: [],
    distributions: [], //Массив элементов http://www.w3.org/ns/dcat#distribution (распространение содержимого)
    details:{},        //Элементы с детальной информацией . Содержит объект с ключём URI, содержащий данные по объекту
};
export const vasset = (state = { ...initialVAssetState}, action) => {
    switch (action.type) {
        case "AdmsAsset.EMPTY":
            return{
                ...initialVAssetState,
            }
        case "AdmsAsset.LOAD_STARTED":
            return{
                ...state,
                state: "load",
            }
        case "AdmsAsset.LOAD_ERROR":
            return {
                ...initialVAssetState,
                state: "error",
                error: action.error
            };
        case "AdmsAsset.LOAD_ASSET":
            return {
                ...state,
                iri: action.iri,
                types: action.types,
                values: action.values,
                head: action.head, 
                predicates: action.predicates, 
                languages: action.languages,
                distributions: action.distributions,
                wikies: action.wikies,
                graphs: action.graphs,
                state: "loaded",
            };
        case "AdmsAsset.LOAD_LABELBYIRI":
            const lbi = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<lbi.length; i++) {
                if (lbi[i].object.value == action.iri)
                    lbi[i].labels = {head: action.head, values: action.values};
            }
            return {
            ...state,
            values: lbi,
        };
        case "AdmsAsset.LOAD_TYPESBYIRI":
            const tbi = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<tbi.length; i++) {
                if (tbi[i].object.value == action.iri)
                    tbi[i].types = action.values;
            }
            return {
            ...state,
            values: tbi,
        };
        case "AdmsAsset.LOAD_DISTRIBUTIONS":
            return {
                ...state,
                distributions: action.distributions
            };

        case "AdmsAsset.RELOAD_DISTRIBUTION": 
            const rld = (Array.isArray(state.distributions))? [...state.distributions]:[];
            const rvd = (Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<rld.length; i++) {
                if (rld[i].object.value == action.iri)
                rld[i].values = action.values;
            };
            for (let i=0; i<rvd.length; i++) {
                if (rvd[i].object.value == action.iri)
                    rvd.values = action.values;
            };
            return {
                ...state,
                values: rvd,
                distributions: rld
            };     
        case "AdmsAsset.LOAD_WIKIES":
            return {
                ...state,
                wikies: action.wikies
            };
        case "AdmsAsset.RELOAD_WIKI":
            const lw = (Array.isArray(state.wikies))? [...state.wikies]:[];
            const lvw = (Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<lw.length; i++) {
                if (lw[i].object.value == action.iri)
                    lw[i].values = action.values;
            };
            for (let i=0; i<lvw.length; i++) {
                if (lvw[i].object.value == action.iri)
                lvw[i].values = action.values;
            };
            return {
                ...state,
                values: lvw,
                wikies: lw
            }; 
        case "AdmsAsset.LOAD_DETAIL":
            const ld = (state.values && Array.isArray(state.values))?[...state.values]:[];
            const {predicat, object } = action.triplet;
            for (let i=0; i<ld.length; i++) {
                if ((ld[i].object.value == object.value) && (ld[i].predicat.value == predicat.value)){
                    ld[i].values = action.values;
                    ld[i].state = action.state;
                    ld[i].head = action.head;
                }
            }
            const {details} = state;
            details[object.value] = {values: action.values, state: action.state, head: action.head};    
            return {
                ...state,
                values: ld,
                details
            };

        case "AdmsAsset.REMOVE_DISTRIBUTION":
            const rd = (state.distributions && Array.isArray(state.distributions))?[...state.distributions]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                distributions: rd.filter(distribution => distribution.object.value!=action.iri)
            };                        

        case "AdmsAsset.REMOVE_WIKI":
            const rw = (state.wikies && Array.isArray(state.wikies))?[...state.wikies]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                wikies: rw.filter(wiki => wiki.object.value!=action.iri)
            };                        
            
        case "AdmsAsset.ADD_DISTRIBUTION":
            const ad = (state.distributions && Array.isArray(state.distributions))?[...state.distributions]: [];
            ad[ad.length] = {predicat: {type: "uri", value: "http://www.w3.org/ns/dcat#distribution"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                distributions: ad
            };                                
            
        case "AdmsAsset.ADD_WIKI":
            const aw = (state.wikies && Array.isArray(state.wikies))?[...state.wikies]: [];
            aw[aw.length] = {predicat: {type: "uri", value: "http://purl.semanticpro.org/ontologies/sksa/wiki"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                wikies: aw
            };        
        case "AdmsAsset.GRAPH_STATE":
            const graphs = (state.graphs && Array.isArray(state.graphs))?[...state.graphs]:[];
            const hasGraph = graphs.filter(graph => graph.iri == action.iri).length>0; 
            if (hasGraph)
                for (let i=0; i<graphs.length; i++) {
                    if (graphs[i].iri == action.iri){
                        graphs[i].state = action.state;
                        break;
                    }
                }
            else 
                graphs.push({iri:action.iri, state: action.state});
            return {
                ...state,
                graphs
            }                         
    default:
            return state;
    }
}



/** Описание списка карталогов */
const initialCatalogs = {
    state: "empty",         //Состояние загрузки списка каталогов
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 10,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["graph", "catalog"]},
    distinct: false,
    ordered: true,    
    graphs: [],             //Список графов, в котором есть каталог
    items: [],              //Список полученных в результате отбора
};

export const vcatalogs = (state = { ...initialCatalogs} , action) => {
    switch (action.type) {
        case "DcatCatalogs.EMPTY": 
            return{
                ...initialCatalogs,
                state: "empty"
            }
        case "DcatCatalogs.SET_RFILTER": 
            return{
                ...state,
                rfilter: action.rfiter,
                state: "empty",
                items: [],
            }            
        case "DcatCatalogs.CONDITIONS":
            return{
                ...state,
                items: [],
                offset: 0,
                conditions: action.conditions,
                state: "empty"
            }
        case "DcatCatalogs.LOAD_STARTED": 
            return{
                ...state,
                state: "load"
            }
        case "DcatCatalogs.LOAD_ERROR": 
            return {
                ...state,
                state: "error",
                error: action.error
            };
        case "DcatCatalogs.GPAPHS":         
            return {
                ...state,
                graphs: action.graphs.map(item => item["graph"].value),
            };
        case "DcatCatalogs.LOAD_CATALOGS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                items: action.items,
                state: "loaded",
            };
        case "DcatCatalogs.LOAD_NEXTCATALOGS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                items: [...state.items, ...action.items],
                state: "loaded",
            };
        case "DcatCatalogs.PUSH":
            return {
                ...state,
                stack : {...state}
            }            
        case "DcatCatalogs.POP":
            const pop = (state.stack)? state.stack: state;
            return {
                ...pop,
            }            
        default:
            return state;
    }
};
